module.exports = __webpack_public_path__ + "assets/pdf/E18-cn-extreme-rainfall.f2b0e454.pdf";